<template>
  <b-modal
    ref="registeredStudentsModal"
    hide-footer
    title="Are you sure?"
    centered
    lazy
    size="md"
    scrollable
    @hide="hideModal"
  >
    <p>Are you sure you want to decline the request?</p>

    <b-form @submit.prevent="onSubmit">
      <b-form-group label="Decline Reason" label-for="cancellation_reason" label-class="form-label">
        <b-form-textarea
          id="cancellation_reason"
          maxlength="250"
          placeholder="Enter reason"
          :rows="4"
          required
          v-model="reason"
        />
      </b-form-group>

      <div class="row">
        <div class="ml-auto" style="margin-right: 12px">
          <b-button @click.prevent="hideModalManual(true)" size="sm">Cancel</b-button>
          <b-button type="submit" variant="danger" size="sm" class="ml-2">Confirm</b-button>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { get } from 'lodash';
import { REFUND_STATUSES } from '@/common/constants';

export default {
  name: 'DeclinedStatusModal',

  props: {
    showModal: { type: Boolean, default: false },
  },

  data() {
    return {
      reason: '',
      isLoading: false,
      REFUND_STATUSES,
    };
  },

  computed: {},

  watch: {
    showModal(value) {
      if (value) {
        this.isLoading = true;

        this.$refs.registeredStudentsModal.show();
      }
    },
  },

  methods: {
    get,

    hideModal(no = false) {
      this.reason = '';
      this.$emit('close', no);
    },

    hideModalManual(no = false) {
      this.$refs.registeredStudentsModal.hide();
      this.hideModal(no);
    },

    async onSubmit() {
      const data = {
        status: REFUND_STATUSES.DECLINED,
        review_reason: this.reason,
        is_reg_cancelled: false,
      };

      this.$emit('onDeclined', data);
      this.hideModalManual();
    },
  },

  async mounted() {},
};
</script>
